/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import SubscriptionCenterService from 'cio/services/subscription-center';

interface SubscriptionCenterTopicDropdownArgs {
  selectedTopic?: string;
  onTopicChange: (topic: { value: string; label: string } | null) => null;
  disabled?: boolean;
  labelClassNames?: string;
}

export default class SubscriptionCenterTopicDropdown extends Component<SubscriptionCenterTopicDropdownArgs> {
  @service subscriptionCenter!: SubscriptionCenterService;

  constructor(owner: unknown, args: SubscriptionCenterTopicDropdownArgs) {
    super(owner, args);

    this.subscriptionCenter.initializeTask.perform();
  }

  get subscriptionTopics() {
    if (!this.subscriptionCenter.initialized || this.subscriptionCenter.initializeTask.isRunning) {
      return [];
    }

    let options = this.subscriptionCenter.topics.map((topic) => ({
      label: topic.name,
      value: topic.id,
    }));

    return [{ label: 'None', value: '0' }, ...options];
  }

  get subscriptionTopicsDisabled() {
    return this.subscriptionCenter.initializeTask.isRunning || this.args.disabled;
  }
}
